import { render, staticRenderFns } from "./succession-files-table.vue?vue&type=template&id=1f52a426&"
import script from "./succession-files-table.vue?vue&type=script&lang=js&"
export * from "./succession-files-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports